import {IPassengerTypeMutationDescriptor} from "./passenger-view-model.interface";
import {MaturePassengerModel} from "./mature-passenger.model";
import {PassengerTypeCodesEnum} from "../../../passenger-types/passenger-type-codes.enum";

export class MaturePassengerTypeMutationDescriptor implements IPassengerTypeMutationDescriptor {
    constructor(private readonly passenger: MaturePassengerModel,
                public readonly mainPassengerType: PassengerTypeCodesEnum,
                mainPassengerTypeFlavours: PassengerTypeCodesEnum[],
                private readonly getDescription: () => string) {
        this._possiblePassengerTypes = [mainPassengerType, ...mainPassengerTypeFlavours];
    }

    private readonly _possiblePassengerTypes: PassengerTypeCodesEnum[]

    get description(): string {
        return this.getDescription();
    }
    get isSelected(): boolean {
        return this._possiblePassengerTypes.includes(this.passenger.scheduledPassengerTypeChange ?? this.passenger.passengerType.code);
    }

    toggle(): void {
        if(this.passenger.scheduledPassengerTypeChange) {
            if(this._possiblePassengerTypes.includes(this.passenger.scheduledPassengerTypeChange)) {
                this.passenger.scheduledPassengerTypeChange = null;
            } else {
                this.passenger.scheduledPassengerTypeChange = this.mainPassengerType;
            }
        } else {
            if(this._possiblePassengerTypes.includes(this.passenger.passengerType.code)) {
                this.passenger.scheduledPassengerTypeChange = this.passenger.originalPassengerTypeCode;
            } else {
                this.passenger.scheduledPassengerTypeChange = this.mainPassengerType;
            }
        }
    }
}